export default "__VITE_ASSET__37fe3021__"